import { render, staticRenderFns } from "./EditPublicationBasedChannel.vue?vue&type=template&id=72579fe2&"
import script from "./EditPublicationBasedChannel.vue?vue&type=script&lang=js&"
export * from "./EditPublicationBasedChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports